/* eslint-disable sort-keys */
/* eslint-disable no-process-env */
module.exports = {
  'APIS': {
    'ADA_BASE_URL': process.env.REACT_APP_API_BASE_URL,
    'APIARY_BASE_URL': process.env.REACT_APP_API_BASE_URL_APIARY,
    'OEF_BASE_URL': process.env.REACT_APP_API_BASE_URL_OEF,
    'HERMES_BASE_URL': process.env.REACT_APP_API_BASE_URL_HERMES,
    'PROMOTION_API_BASE_URL': process.env.REACT_APP_PROMOTION_API_BASE_URL,
  },
  'ENV': process.env.NODE_ENV,
  'IS_PROD': process.env.REACT_APP_IS_PRODUCAO === 'true',
  'PACKAGES': {
    'ADYEN': process.env.REACT_APP_CHAVE_CRIPTO_ADYEN,
    'GOOGLE_ANALYTICS': process.env.REACT_APP_GOOGLE_ANALYTICS,
    'GOOGLE_ANALYTICS_ENABLED': process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED,
    'HOTJAR': process.env.REACT_APP_HOTJAR,
    'HOTJAR_ENABLED': process.env.REACT_APP_HOTJAR_ENABLED,
    'FACEBOOK_PIXEL': process.env.REACT_APP_FACEBOOK_PIXEL,
    'FACEBOOK_PIXEL_ENABLED': process.env.REACT_APP_FACEBOOK_PIXEL_ENABLED,
    'GOOGLE_TAGMANAGER_ID': process.env.REACT_APP_GOOGLE_TAGMANAGER_ID,
    'GOOGLE_TAGMANAGER_ENABLED': process.env.REACT_APP_GOOGLE_TAGMANAGER_ENABLED,
    'GTM_CHECKOUT_ENV': process.env.REACT_APP_GTM_CHECKOUT_ENV,
    'GTM_CHECKOUT_PREVIEW': process.env.REACT_APP_GTM_CHECKOUT_PREVIEW,
    'RECAPTCHA_KEY': process.env.REACT_APP_RECAPTCHA_KEY,
    'NEWRELIC_ENABLED': process.env.REACT_APP_NEWRELIC_ENABLED,
  },
  'SERVER': {
    'PORT': process.env.PORT
  },
  'URLS_APP': {
    'BASE_PATH': process.env.REACT_APP_BASE_PATH,
    'CANONICAL_URL': process.env.REACT_APP_CANONICAL_URL,
    'URL_CHECKOUT_BOOKSTER': process.env.REACT_APP_URL_CHECKOUT_BOOKSTER
  }
}
